import { render, staticRenderFns } from "./WaiterJudgementSwitch.vue?vue&type=template&id=a3599838&scoped=true&lang=pug"
import script from "./WaiterJudgementSwitch.vue?vue&type=script&lang=ts"
export * from "./WaiterJudgementSwitch.vue?vue&type=script&lang=ts"
import style0 from "./WaiterJudgementSwitch.vue?vue&type=style&index=0&id=a3599838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3599838",
  null
  
)

export default component.exports